import { map } from 'lodash'
import { success, error } from '@/utils/alert'
import moment from 'moment'

export default {
  formatDate (date) {
    return moment(date).format('DD/MM')
  },
  doCancelAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/cancel')
      .then(({data}) => {
        success('Horário(s) definidos como cancelado como suscesso.')
        this.$emit('close', data)
      })
      .catch(() => {
        error('Ocorreu um erro no cancelamento')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/active-agenda/components/cancel/resources/methods.js